<template>
  <Layout>
    <ServerStatusListPage
      title="In Review Applications"
      subtitle="Applications a staff reviewer has picked up and is currently checking."
      card-title="In Review"
      icon="clock"
      tone="blue"
      by-label="Assigned To"
      search-placeholder="Search in review application..."
      empty-message="No applications are in review"
      endpoint="/applications/all_application_details/"
      status="in_review"
      server-status-filter
    />
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import ServerStatusListPage from "@/components/shared/ServerStatusListPage.vue";

// Admin: applications whose status is "in_review". Paged, searched and sorted on the server;
// page / search / sort stay in the URL.
export default {
  components: {
    Layout,
    ServerStatusListPage,
  },
};
</script>